<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            increases: [],
            form: {
                buy_id: '',
                name: '',
                amount: '',
                date: '',
                description: '',
                file: '',
            },
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.buy_id = '';
            this.form.name = '';
            this.form.amount = '';
            this.form.date = '';
            this.form.description = '';
            this.increases = [];
            this.$modal.hide('addBuyIncreases');
        },
        async list() {
            let _endpoint = '/buys_increases?id=' + this.form.buy_id;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.increases = data;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        async saveBuildings() {
            this.send = true;
            let form = this.form;
            let _endpoint = '/buys_increases';         
            try {
                let { data } = await request.postMedia(_endpoint, form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-buys');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                    this.send = false;
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-addBuyIncreases", (buy) => {
            this.form.buy_id = buy.id;
            this.list();
            this.$modal.show('addBuyIncreases');
        });
    },
}
</script>
<template>
    <modal v-bind:click-to-close="false" name="addBuyIncreases" :width="'80%'" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar aumento de compra</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="card p-0">
                        <div class="card-body">
                            <div class="row">

                                <div class="col-md-12 mt-2">
                                    <label>Nombre</label>
                                    <input class="form-control" v-model="form.name">
                                    <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
                                </div>

                                <div class="col-md-12 mt-2">
                                    <label>Monto</label>
                                    <money class="form-control" v-model="form.amount">
                                    </money>
                                    <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                                </div>

                                <div class="col-md-12 mt-2">
                                    <label>Fecha</label>
                                    <date-picker v-model="form.date" valueType="format"
                                        :disabled="!prop_edit"></date-picker>
                                    <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                                </div>

                                <div class="col-md-12 mt-2">
                                    <label>Descripción</label>
                                    <textarea type="text" class="form-control" v-model="form.description" rows="2"
                                        :disabled="!prop_edit"></textarea>
                                    <div v-if="errors && errors.description" class="text-danger">{{
                                        errors.description[0] }}
                                    </div>
                                    <hr>
                                </div>

                                <div class="col-md-12 text-right">
                                    <button :disabled="send" type="button" class="btn btn-outline-success btn-sm"
                                        @click="saveBuildings()">
                                        <span v-if="send">
                                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                                        </span>
                                        <span v-else>
                                            <i class="fas fa-save"></i> Guardar
                                        </span>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-12 table-responsive">
                            <table class="table table-bordered text-center text-sm">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre</th>
                                        <th>Monto</th>
                                        <th>Fecha</th>
                                        <th>Descripción</th>
                                    </tr>
                                </thead>
                                <tbody v-if="load">
                                    <tr>
                                        <td align="center" colspan="5">
                                            <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                            <h5>Cargando</h5>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="increases.length > 0">
                                    <tr v-for="(increase, index) in increases" :key="index">
                                        <td>{{ increase.id }}</td>
                                        <td>{{ increase.name }}</td>
                                        <td>{{ increase.amount | toCurrency }}</td>
                                        <td>{{ increase.date | toDateTime }}</td>
                                        <td>{{ increase.description }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td align="center" colspan="5">Sin resultados.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>